export default "__VITE_ASSET__KOa8gIas__"